import React, { useMemo, useState } from "react";
import styles from "./index.module.scss";
import { Button, Input, Select, Tooltip } from "antd";
import {
    CourseListItem,
    getCourseListByExam,
    getExamListByInvigilation,
    getExamStudentAllMonitorListProps,
    StudentAllRecordListItem
} from "service/exam";
import Form from "rc-field-form";
import FieldWithError from "../../../../../../components/FieldWithError";
import useRequest from "../../../../../../utils/useRequest";
import ActionMenu from "../../../../invigilationLog&supervise_Components/ActionMenu";
import useRequestFn from "../../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";

interface InvigilationSearchProps {
    data: StudentAllRecordListItem[];
    examId: string;
    defaultExamId: string | undefined;
    stuNos: string[];
    onSearch: (params: getExamStudentAllMonitorListProps | undefined) => void;
}

export default function InvigilationSearch({
    data,
    defaultExamId,
    examId,
    stuNos,
    onSearch
}: InvigilationSearchProps) {
    const [options, { loading: optionsLoading }] = useRequest(
        getExamListByInvigilation
    );
    const [form] = Form.useForm<getExamStudentAllMonitorListProps>();

    function onFinish(data: getExamStudentAllMonitorListProps) {
        onSearch(data);
    }

    const [courseOptions, setCourseOptions] = useState<CourseListItem[]>([]);
    const [getCourse, { loading: courseLoading }] =
        useRequestFn(getCourseListByExam);
    async function examChange(examId: string) {
        try {
            const d = await getCourse(examId);
            await setCourseOptions(d);
            form.setFieldsValue({ course: "" });
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const examDisabled = useMemo(() => {
        if (defaultExamId) {
            examChange(defaultExamId);
            return true;
        }
    }, [defaultExamId]);

    return (
        <Form form={form} onFinish={onFinish} className={styles.root}>
            考核<span style={{ color: "red" }}>*</span>
            <FieldWithError
                initialValue={
                    typeof defaultExamId === "string"
                        ? parseInt(defaultExamId)
                        : ""
                }
                rules={[{ required: true, message: "请选择考核" }]}
                name="examId">
                <Select
                    disabled={examDisabled}
                    loading={[optionsLoading, courseLoading].some(i => i)}
                    style={{ width: 150 }}
                    onChange={examChange}>
                    {options?.map(item => (
                        <Select.Option key={item.examId} value={item.examId}>
                            {item.examName}
                        </Select.Option>
                    ))}
                </Select>
            </FieldWithError>
            课程
            <Form.Field name="course">
                <Select
                    loading={courseLoading}
                    className={styles.input}
                    allowClear>
                    {courseOptions?.map((item, index, arr) => (
                        <Select.Option
                            key={Object.values(arr).join()}
                            value={`${item.courseNo}_${item.courseSeq}`}>
                            <Tooltip
                                placement="left"
                                title={`${item.courseNo}_${item.courseSeq}_${item.courseName}`}>
                                {`${item.courseNo}_${item.courseSeq}_${item.courseName}`}
                            </Tooltip>
                        </Select.Option>
                    ))}
                </Select>
            </Form.Field>
            考生信息
            <Form.Field name="studentName">
                <Input
                    placeholder="请输入姓名、学号"
                    className={styles.input}
                />
            </Form.Field>
            <Button icon="search" type="primary" htmlType="submit">
                查询
            </Button>
            <ActionMenu
                examId={examId}
                stuNos={stuNos}
                onOk={() => onSearch(undefined)}
                disabled={stuNos.length === 0}
            />
        </Form>
    );
}
